import PropTypes from 'prop-types';
import React from 'react';

import {
  Button,
  ButtonRow,
  HorizontalRule,
  ModalDialog,
  Paragraph,
} from '@piggybank/core';

import nls from './nls/TimeoutDialog';
import { createTranslator } from '~/lib/nls-helper';

const NLS = createTranslator(nls);

const TimeoutDialog = ({ children, extendSession, show, timeoutCountDown }) => {

  return (
    <ModalDialog
      dismissible={false}
      show={show && timeoutCountDown >= 0}
      title={NLS`Need more time?`}
    >
      {children}
      <Paragraph>
        <span role="timer">
          {NLS`Your session will automatically close in`} <strong>{timeoutCountDown}</strong> {timeoutCountDown === 1 ? NLS`second` : NLS`seconds`}
        </span>
      </Paragraph>
      <Paragraph>{NLS`Make sure not to leave incomplete information, otherwise it won’t be saved.`}</Paragraph>
      <HorizontalRule />
      <ButtonRow>
        <Button onClick={extendSession} type="button">{NLS`Stay in session`}</Button>
      </ButtonRow>
    </ModalDialog>
  );
};

TimeoutDialog.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  extendSession: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  timeoutCountDown: PropTypes.number.isRequired,
};

export default TimeoutDialog;
